import ServiceDetailPage from "@/components/ServiceDetailPage";

const Interview = () => <ServiceDetailPage pageKey="interview" />;

export default Interview;
